export class GameVars {

    public static gameData: GameData;
    public static language: string;
    public static gameText: any;
    public static currentScene: Phaser.Scene;
    public static paused: boolean;
    public static difficulty: string;
    public static genre: string;
    public static players: PlayerInfo[];
    public static roundBonus: number;
    public static tutorialCount: number;
    public static gameOver: boolean;

    public static cards: CardValue[];
    public static topCardDeck: number;
    public static topCardWaste: CardValue;

    public static currentTurn: number;
    public static round: number;
    public static needStop: number;
    public static lastPosition: number;
    public static firstTurn: number;
    public static removePlayer: number;
    public static numPlayers: number;

    public static typeAd: string;
    
    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
